import Vue from 'vue'
import VueRouter from 'vue-router'
import API from './http-common.js'
import config from './config'

import Layout from './components/Layout/Layout.vue'

//share page
import ChangePassword from './components/Share/ChangePassword.vue'
import MerchantUserList from './components/Share/MerchantUserList.vue'
import CustomerList from './components/Share/CustomerList.vue'
import BatchEcouponList from './components/Share/BatchEcouponList.vue'
import BatchEcouponReminder from './components/Share/BatchEcouponReminder.vue'
import BatchEcouponDetail from './components/Share/BatchEcouponDetail.vue'
import FlexibleEcouponList from './components/Share/FlexibleEcouponList.vue'
import FlexibleEcouponDetail from './components/Share/FlexibleEcouponDetail.vue'
import EcouponList from './components/Share/EcouponList.vue'
import EcouponEdit from './components/Share/EcouponEdit.vue'
import Report from './components/Share/Report.vue'
import EcouponUsageReport from './components/Share/EcouponUsageReport.vue'

//admin
import AdminLogin from './components/Admin/Login.vue'
import AdminForgotPassword from './components/Admin/ForgotPassword.vue'
import AdminResetPassword from './components/Admin/ResetPassword.vue'
import AdminMerchantList from './components/Admin/MerchantList.vue'
import AdminUserList from './components/Admin/AdminList.vue'
import AdminAuditLog from './components/Admin/AuditLog.vue'

//merchant
import MerchantLogin from './components/Merchant/Login.vue'
import MerchantForgotPassword from './components/Merchant/ForgotPassword.vue'
import MerchantResetPassword from './components/Merchant/ResetPassword.vue'
import MerchantRedeemEcoupon from './components/Merchant/RedeemEcoupon.vue'
import MerchantVoidEcoupon from './components/Merchant/VoidEcoupon.vue'
import MerchantRedemptionPIN from './components/Merchant/RedemptionPINCode.vue'
import MerchantApiDoc from './components/Merchant/ApiDoc.vue'

//page not found
import PageNotFound from './components/PageNotFound.vue'

Vue.use(VueRouter)
let appPath = config.APP_ROOT_PATH;

const routes = [
  //admin
  { path: appPath + 'admin/login', name: 'adminLogin', component: AdminLogin },
  { path: appPath + 'admin/forgot', name: 'adminForgotPassword', component: AdminForgotPassword },
  { path: appPath + 'admin/:token/reset', name: 'adminResetPassword', component: AdminResetPassword },
  {
    path: appPath + 'admin', component: Layout, children: [
      { path: '', redirect: { name: 'adminMerchantList' } }, //default
      { path: 'merchant', name: 'adminMerchantList', component: AdminMerchantList },
      { path: 'merchantuser', name: 'adminMerchantUserList', component: MerchantUserList },
      { path: 'customer', name: 'adminCustomerList', component: CustomerList },
      { path: 'batchecoupon', name: 'adminBatchEcouponList', component: BatchEcouponList },
      //{ path: 'batch-ecouponreminder', name: 'adminBatchEcouponReminder', component: BatchEcouponReminder },
      { path: 'batchecoupon/:id', name: 'adminBatchEcouponDetail', component: BatchEcouponDetail },
      { path: 'flexibleecoupon', name: 'adminFlexibleEcouponList', component: FlexibleEcouponList },
      { path: 'flexibleecoupon/:id', name: 'adminFlexibleEcouponDetail', component: FlexibleEcouponDetail },
      { path: 'ecoupon', name: 'adminEcouponList', component: EcouponList },
      { path: 'ecoupon/add', name: 'adminEcouponAdd', component: EcouponEdit },
      { path: 'ecoupon/usage-report', name: 'adminEcouponUsageReport', component: EcouponUsageReport },
      { path: 'report', name: 'adminReport', component: Report },
      { path: 'adminuser', name: 'adminUserList', component: AdminUserList },
      { path: 'auditlog', name: 'adminAuditLog', component: AdminAuditLog },
      { path: 'changepassword', name: 'adminChangePassword', component: ChangePassword }
    ], beforeEnter(to, from, next) {
      if (from.name == 'adminLogin') return next();
      let data = JSON.parse(localStorage.getItem('emstoken'))
      if (!data) return next({ name: 'adminLogin' })
      API.verifyToken({}, { headers: { Authorization: `Bearer ${data.token}` } }).then(response => {
        if (response.status == 200 && response.data == true) {
          return next()
        } else {
          localStorage.removeItem('emstoken')
          return next({ name: 'adminLogin' })
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'adminLogin' })
      })
    }
  },
  //merchant
  { path: appPath + 'merchant/login/:code', name: 'merchantLogin', component: MerchantLogin },
  { path: appPath + 'merchant/forgot/:code', name: 'merchantForgotPassword', component: MerchantForgotPassword },
  { path: appPath + 'merchant/:token/reset', name: 'merchantResetPassword', component: MerchantResetPassword },
  {
    path: appPath + 'merchant', component: Layout, children: [
      { path: '', redirect: { name: 'merchantCustomerList' } }, //default
      { path: 'merchantuser', name: 'merchantMerchantUserList', component: MerchantUserList },
      { path: 'customer', name: 'merchantCustomerList', component: CustomerList },
      { path: 'apidoc', name: 'merchantApiDoc', component: MerchantApiDoc },
      { path: 'batchecoupon', name: 'merchantBatchEcouponList', component: BatchEcouponList },
      { path: 'batch-ecouponreminder', name: 'merchantBatchEcouponReminder', component: BatchEcouponReminder },
      { path: 'batchecoupon/:id', name: 'merchantBatchEcouponDetail', component: BatchEcouponDetail },
      { path: 'flexibleecoupon', name: 'merchantFlexibleEcouponList', component: FlexibleEcouponList },
      { path: 'flexibleecoupon/:id', name: 'merchantFlexibleEcouponDetail', component: FlexibleEcouponDetail },
      { path: 'ecoupon', name: 'merchantEcouponList', component: EcouponList },
      { path: 'ecoupon/add', name: 'merchantEcouponAdd', component: EcouponEdit },
      { path: 'redemptionpin', name: 'merchantRedemptionPin', component: MerchantRedemptionPIN },
      { path: 'redeem', name: 'merchantRedeem', component: MerchantRedeemEcoupon },
      { path: 'void', name: 'merchantVoid', component: MerchantVoidEcoupon },
      { path: 'report', name: 'merchantReport', component: Report },
      { path: 'changepassword', name: 'merchantChangePassword', component: ChangePassword }
    ], beforeEnter(to, from, next) {
      if (from.name == 'merchantLogin') return next();
      let data = JSON.parse(localStorage.getItem('emstoken'))
      if (!data) return next({ name: 'merchantLogin' })
      API.verifyToken({}, { headers: { Authorization: `Bearer ${data.token}` } }).then(response => {
        if (response.status == 200 && response.data == true) {
          return next()
        } else {
          localStorage.removeItem('emstoken')
          return next({ name: 'merchantLogin' })
        }
      }).catch(error => {
        console.log(error)
        return next({ name: 'merchantLogin' })
      })
    }
  },
  { path: '*', name: 'pageNotFound', component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router.js